import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Flex } from 'core/ui/atoms';
import CHECK_IMAGE from 'johari/assets/check_circle.svg';

const Trait = ({ trait, isSelected, gender, toggleTrait, disabled }) => {
  const { t } = useTranslation();
  return (
    <Wrap>
      <Cont
        isSelected={isSelected}
        onClick={disabled ? null : toggleTrait}
        disabled={!isSelected && disabled}
      >
        {t(`Traits.${trait}${gender === 'FEMALE' ? '_female' : ''}`)}
        {isSelected ? <img src={CHECK_IMAGE} /> : null}
      </Cont>
    </Wrap>
  );
};

Trait.propTypes = {
  trait: PropTypes.string,
  gender: PropTypes.string,
  isSelected: PropTypes.bool,
  toggleTrait: PropTypes.func,
  disabled: PropTypes.bool,
};

const Wrap = styled.div`
  width: ${100 / 3}%;
  padding-right: 25px;
  margin-bottom: 13px;
  ${(p) => p.theme.max('sm')`
    width: 100%;
    padding-right: 0;
    margin-bottom: 8px;
  `};
`;

const Cont = styled((p) => (
  <Flex justifyContent={'space-between'} alignItems={'center'} {...p} />
))`
  height: 40px;
  background: ${(p) =>
    p.isSelected
      ? `linear-gradient(90deg, ${p.theme.colors.primary}, ${p.theme.colors.secondary})`
      : p.theme.colors.gray.lighter};
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-sizing: border-box;
  backdrop-filter: blur(20px);
  border-radius: 110px;
  cursor: pointer;
  color: ${(p) => (p.isSelected ? 'white' : '#333333')};
  padding: 0 15px;
  font-weight: 600;
  ${(p) =>
    p.disabled &&
    css`
      opacity: 0.3;
    `};
  ${(p) => p.theme.max('sm')`
    
  `};
`;

export default Trait;
